// extracted by mini-css-extract-plugin
export default {"cls1":"XxN5QReYK5Wxmat0kQbt","cls2":"BaOsienFuUuZzFaqPwIw XxN5QReYK5Wxmat0kQbt"};